import { env } from '@ria-client/env';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type WPBlockProps = NodeProps<{
  content: StructuredContent | StructuredContent[];
  id?: number | string;
}>;

export function WPBlock({ props }: WPBlockProps) {
  if (!props.id) {
    const environment = env.NEXT_PUBLIC_DEPLOYABLE_ENV;
    if (environment === 'stage' || environment === 'dev') {
      console.warn(`WPBlock Structured Content Renderer missing content for doc id: ${props.id}`);
    }
    return null;
  }

  return <StructuredContentRenderer doc={props.content} />;
}
